import styles from './verse.module.css'

const Verse = ({active, id, className, children, onClick, ...props}) => {
  const onKeyDown = e => {
    if (e.code == 'Enter' || e.code == 'Space') {
      e.preventDefault()
      onClick()
    }
  }

  return (
    <div
      className={className ? `${styles.verse} ${className}` : styles.verse}
      data-id={id}
      role="button"
      tabIndex={0}
      aria-pressed={!!active}
      onClick={onClick}
      onKeyDown={onKeyDown}
      {...props}
    >
      <div className={styles.text}>{children}</div>
    </div>
  )
}

export default Verse
